// extracted by mini-css-extract-plugin
module.exports = {"simulatorInput":"MoneyInput_simulatorInput__5sosq","input":"MoneyInput_input__cdkyi"};